import { isDarkScheme } from '../../utils/colorScheme';
export const getGridLinesColor = () => isDarkScheme() ? 'rgba(255, 255, 255, 0.09)' : 'rgba(0, 0, 0, 0.09)';
export const defaultChartOptions = {
    responsive: true,
    title: {
        display: false,
        text: '',
    },
    tooltips: {
        mode: 'index',
        intersect: false,
        position: 'nearest',
        callbacks: {},
    },
    legend: {
        labels: {
            filter: (item /*, chart*/) => item.datasetIndex !== 1 && item.datasetIndex !== 3,
        },
    },
    hover: {
        mode: 'index',
        intersect: false,
    },
    scales: {
        xAxes: [
            {
                gridLines: {
                    color: getGridLinesColor(),
                },
                stacked: true,
                scaleLabel: {
                    display: false,
                    labelString: 'Commits',
                },
                ticks: {
                    maxRotation: 0,
                    maxTicksLimit: 13,
                },
            },
        ],
        yAxes: [
            {
                gridLines: {
                    color: getGridLinesColor(),
                },
                stacked: true,
                scaleLabel: {
                    display: false,
                    labelString: 'Values',
                },
                ticks: {
                    beginAtZero: true,
                    max: Infinity,
                    min: 0,
                    callback: (value) => (Math.floor(value) === value ? value : void 0), // filter decimal values in y axis
                },
            },
            {
                id: 'threshold',
                display: false,
                type: 'linear',
                position: 'right',
                ticks: {
                    beginAtZero: true,
                    max: Infinity,
                    min: 0,
                    suggestedMax: 0,
                },
            },
        ],
    },
};
